// TODO: 

// implement data generation for demo accounts:
// - with actual date and time
// - with real like title and description
// - with all types of categories
// - with different statuses
// - with different assignees
// - with different creators

// fix icons
// fix category labels
// add more tasks and events

//

/*
 theme list: emotional, home, childcare, legal, general, medical (create example tasks with this themes!)
 //
 status list: initial, in_progress, completed
 assignee: null, demo user, family member, coordinator, caregiver
 creator: demo user, family member, coordinator, caregiver
*/

class DemoAccount {
    constructor() {
        const storedData = localStorage.getItem('demoAccount_2');
        const creator = {
            full_name: "Demo Tasks",
            formatted_phone_number: "+1231234567890"
        };
        //
        localStorage.setItem('demoAccount', "demo account data version 2"); // to reset old demo data
        //
        if (storedData) {
            const { no_time, events, family, supporter } = JSON.parse(storedData);
            this.no_time = no_time;
            this.events = events;
            this.family = family;
            this.supporter = supporter;
        } else {
            this.family = {
                "title": "The Demo Family",
                "tasks_counter": {
                    "initial": 3,
                    "in_progress": 2,
                    "completed": 0,
                    "my_tasks": 3
                },
                "coordinator": { "full_name": "Demo coordinator", "formatted_phone_number": "+00-000-000-00-00" },
                "primary_caregiver": { "full_name": "Demo caregiver", "formatted_phone_number": "+00-000-000-00-00" }
            };

            this.supporter = {
                "full_name": "Example User",
                "formatted_phone_number": "+00-000-000-00-00"
            };

            function generateRandomDate() {
                const today = new Date();
                const futureDate = new Date();
                futureDate.setDate(today.getDate() + 7);

                const randomDate = new Date(
                    today.getTime() +
                    Math.random() * (futureDate.getTime() - today.getTime())
                );

                return randomDate.toISOString().split('T')[0];
            }

            this.no_time = [
                {
                    "category": "general",
                    "id": 1,
                    "type": "no_time",
                    "title": "Weekly team meeting preparation",
                    "description": "Prepare agenda and materials for the weekly team sync",
                    "status": "initial",
                    "assigned_on_me": false,
                    "assignee": null,
                    "start_at": null,
                    "end_at": null,
                    "creator": creator
                },
                {
                    "category": "medical",
                    "id": 2,
                    "type": "no_time",
                    "title": "Doctor appointment follow-up",
                    "description": "Schedule follow-up appointment and update medical records",
                    "status": "in_progress",
                    "assigned_on_me": true,
                    "assignee": this.supporter,
                    "start_at": null,
                    "end_at": null,
                    "creator": creator
                },
                {
                    "category": "home",
                    "id": 3,
                    "type": "no_time",
                    "title": "Grocery shopping list",
                    "description": "Create shopping list for weekly groceries and household items",
                    "status": "in_progress",
                    "assigned_on_me": true,
                    "assignee": this.supporter,
                    "start_at": null,
                    "end_at": null,
                    "creator": creator
                }
            ];

            this.events = [
                {
                    "category": "childcare",
                    "id": 4,
                    "type": "until_time",
                    "title": "Parent-teacher conference",
                    "description": "Attend quarterly parent-teacher meeting at school",
                    "status": "in_progress",
                    "task_id": 5,
                    "assigned_on_me": true,
                    "assignee": this.supporter,
                    "date": generateRandomDate(),
                    "start_at": "18:30:00+0000",
                    "end_at": "19:30:00+0000",
                    "creator": creator
                },
                {
                    "category": "legal",
                    "id": 6,
                    "type": "until_time",
                    "title": "Contract review session",
                    "description": "Review and finalize service agreement with legal team",
                    "status": "initial",
                    "task_id": 7,
                    "assigned_on_me": false,
                    "assignee": null,
                    "date": generateRandomDate(),
                    "start_at": "14:00:00+0000",
                    "end_at": "15:30:00+0000",
                    "creator": creator
                },
                {
                    "category": "emotional",
                    "id": 8,
                    "type": "until_time",
                    "title": "Therapy session",
                    "description": "Weekly counseling session for stress management",
                    "status": "initial",
                    "task_id": 9,
                    "assigned_on_me": false,
                    "assignee": null,
                    "date": generateRandomDate(),
                    "start_at": "16:00:00+0000",
                    "end_at": "17:00:00+0000",
                    "creator": creator
                }
            ];

            this.saveToLocalStorage();
        }
    }

    // --- INTERNAL HELPERS ---
    _find(list, id) {
        return list.find(t => t.id === id) || null;
    }

    _updateAndSave() {
        this.saveToLocalStorage();
        return true;
    }

    // --- ASSIGN ---
    assign_task(id) {
        const t = this._find(this.no_time, id);
        if (!t) return false;

        t.status = "in_progress";
        t.assigned_on_me = true;
        t.assignee = this.supporter;

        return this._updateAndSave();
    }

    assign_event(id) {
        const t = this._find(this.events, id);
        if (!t) return false;

        t.status = "in_progress";
        t.assigned_on_me = true;
        t.assignee = this.supporter;

        return this._updateAndSave();
    }

    // --- UNASSIGN ---
    unassign_task(id) {
        const t = this._find(this.no_time, id);
        if (!t) return false;

        t.status = "initial";
        t.assigned_on_me = false;
        t.assignee = null;

        return this._updateAndSave();
    }

    unassign_event(id) {
        const t = this._find(this.events, id);
        if (!t) return false;

        t.status = "initial";
        t.assigned_on_me = false;
        t.assignee = null;

        return this._updateAndSave();
    }

    // --- COMPLETE / UNCOMPLETE ---
    complete_task(id) {
        const t = this._find(this.no_time, id);
        if (!t) return false;

        t.status = "completed";

        return this._updateAndSave();
    }

    complete_event(id) {
        const t = this._find(this.events, id);
        if (!t) return false;

        t.status = "completed";

        return this._updateAndSave();
    }

    uncomplete_task(id) {
        const t = this._find(this.no_time, id);
        if (!t) return false;

        t.status = "in_progress"; // или initial — по логике приложения

        return this._updateAndSave();
    }

    uncomplete_event(id) {
        const t = this._find(this.events, id);
        if (!t) return false;

        t.status = "in_progress";

        return this._updateAndSave();
    }

    // --- RESET ---
    reset_demo() {
        localStorage.removeItem('demoAccount_2');
        localStorage.removeItem('demoAccount'); // in case of old version
    }

    logout_demo() {
        localStorage.removeItem('demoAccount_2');
        localStorage.removeItem('demoAccount'); // in case of old version
    }

    // --- SAVE ---
    saveToLocalStorage() {
        localStorage.setItem('demoAccount_2', JSON.stringify({
            supporter: this.supporter,
            family: this.family,
            no_time: this.no_time,
            events: this.events
        }));
    }
}

export default DemoAccount;


